/**
 * Subscription Success Page
 * Shown after successful payment
 */

import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {CheckCircle, Loader} from 'lucide-react';
import SubscriptionLayout from '../components/subscription/SubscriptionLayout';

const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Wait a moment for webhook to process
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const organizationId = searchParams.get('org');

  return (
    <SubscriptionLayout>
      <div className="flex items-center justify-center min-h-[60vh] p-4">
        <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-8 text-center">
        {isLoading ? (
          <>
            <div className="flex justify-center mb-6">
              <Loader className="w-16 h-16 text-purple-600 dark:text-purple-400 animate-spin" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Processing Payment
            </h2>
            <p className="text-gray-600 dark:text-gray-300">
              Please wait while we confirm your subscription...
            </p>
          </>
        ) : (
          <>
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center">
                <CheckCircle className="w-10 h-10 text-green-600 dark:text-green-400" />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Payment Successful!
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Your subscription is now active. You can start using all features immediately.
            </p>
            <button
              onClick={() => {
                // Pass organizationId to subscription page if available
                if (organizationId) {
                  navigate(`/subscription?org=${organizationId}`);
                } else {
                  navigate('/subscription');
                }
              }}
              className="w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all"
            >
              Go to Subscription Dashboard
            </button>
          </>
        )}
        </div>
      </div>
    </SubscriptionLayout>
  );
};

export default SubscriptionSuccessPage;

